var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import ShopActivityService from '../../api/ShopActivityService';
import GoodsList from './components/GoodsList';
import ClientsList from './components/ClientsList';
var ShopActivityDetail = (function (_super) {
    __extends(ShopActivityDetail, _super);
    function ShopActivityDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.activity_id = '';
        _this.formData = {};
        _this.data = [];
        return _this;
    }
    ShopActivityDetail.prototype.created = function () {
        this.service = ShopActivityService.getInstance();
        this.getDetail();
    };
    ShopActivityDetail.prototype.mounted = function () {
        var _this = this;
        var timeout = setTimeout(function () {
            clearTimeout(timeout);
            _this.tableHeight = document.documentElement.clientHeight - 370;
        }, 300);
    };
    ShopActivityDetail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            activity_id: this.activity_id,
        };
        console.log(this.activity_id);
        this.service
            .getDetail(__assign({}, params))
            .then(function (res) {
            loadingInstance.close();
            var data = {};
            data = res.data && res.data.data;
            if (data.activity_type == 1) {
                data.fullMinusList = (data.rule || []).map(function (item) {
                    return {
                        full: item.full,
                        minus: item.reduction,
                    };
                });
            }
            else if (data.activity_type == 2) {
                if (data.activity_sub_type == 21) {
                    data.fullGiftData = data.rule && data.rule.full;
                }
                else if (data.activity_sub_type == 22) {
                    data.fullGiftData = data.rule && data.rule.full;
                }
            }
            else if (data.activity_type == 3) {
                if (data.activity_sub_type == 31) {
                    data.rebateList = data.rule || [];
                }
                else if (data.activity_sub_type == 32) {
                    var rebateEachItem = data.rule[0] || {};
                    data.rebateEach = __assign({}, rebateEachItem);
                }
            }
            else if (data.activity_type == 4) {
                var integralEachItem = JSON.parse(data.param_json);
                data.integralEach = __assign({}, integralEachItem);
            }
            delete data.rule;
            data.businessListData = data.business_info;
            delete data.business_info;
            data.goodsListData = data.activity_goods;
            delete data.activity_goods;
            data.giftListData = data.activity_gift_goods;
            delete data.activity_gift_goods;
            _this.formData = data;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    ShopActivityDetail = __decorate([
        Component({
            components: {
                'goods-list': GoodsList,
                'clients-list': ClientsList,
            }
        })
    ], ShopActivityDetail);
    return ShopActivityDetail;
}(Vue));
export default ShopActivityDetail;
